import { inject, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

/**
 * Be careful! This pipe turns off angular checks on dangerous XSS urls.
 * You must be sure that URL is safe before using it.
 *
 * Without this pipe you can get an error:
 * ERROR RuntimeError: NG0904: unsafe value used in a resource URL context
 */
@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
